module.exports = __webpack_public_path__ + "static/img/login01_04.c6a822e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/login01_04.png
// module id = MXjJ
// module chunks = 0